import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import Vendor from '../../components/vendor';
import Factory from '../../components/factory';
import { get } from '../../services/apiController';
import PaginationInPage from '../Pagination';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import Item from '../../components/item';
import { GrDocumentExcel } from 'react-icons/gr';
import { get_auth_key, getStoredData } from '../../util';
import moment from 'moment';

const RejectedItemsReport = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const [data, setData] = useState([]);
  const clickToDownload = useRef(null);
  const [state, setState] = useState({
    vendorId: '',
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    dateFrom: '',
    dateTo: '',
    itemId: '',
  });
  const [factories, setFactories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const getConsolidatedReport = (download = false) => {
    let url = `/inv/report/rejected-items/?vendorId=${state.vendorId}&factoryId=${state.factoryId}&itemId=${state.itemId}&download=${download}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}`;
    if (!download) {
      url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
    }
    get(url)
      .then((res) => {
        if (download) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setData(res?.data?.data);
          setTotalRecords(res?.data.count);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  };

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    getConsolidatedReport();
  }, [currentPage]);

  useEffect(() => {
    getFactories();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title" style={{ fontSize: '16px' }}>
                Rejected Items Report | {totalRecords ?? 0}
              </h4>
            </div>
          </div>
          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <Vendor
                name="vendorId"
                vendorId={state?.vendorId}
                handleVendorChange={(vendorId) => {
                  setState({ ...state, vendorId });
                }}
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel label="Factory" className="mb-3">
                <Factory
                  factoryId={state.factoryId}
                  disabled={!admins}
                  onChange={(e) => {
                    setState({ ...state, factoryId: e.target.value });
                  }}
                  factories={factories}
                  label="factory"
                  name="factoryId"
                />
              </FloatingLabel>
              <Item
                itemId={state.itemId}
                name="itemId"
                onChange={(itemId) => {
                  setState({ ...state, itemId });
                }}
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="From Date">
                <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
              </FloatingLabel>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="To Date">
                <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div className="d-flex" style={{ maxWidth: '200px', flexDirection: 'column', alignItems: 'center' }}>
              <Button onClick={() => getConsolidatedReport()} type="submit" className="btn app-btn-default dark-color">
                Apply
              </Button>
              <GrDocumentExcel
                title="Download rejected items report"
                className="react-icons green mt-2"
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => getConsolidatedReport(true)}
              />
              <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Rejection Date</th>
                    <th>Vendor</th>
                    <th>Factory</th>
                    <th>Invoice Number</th>
                    <th>Item</th>
                    <th>Qty as per Invoice</th>
                    <th>Quantity Received</th>
                    <th>Quantity Rejected</th>
                    <th>Rejection remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{moment(item.grnDate).format('DD/MM/YYYY')}</td>
                        <td>{item.vendor_name}</td>
                        <td>{item.branch_name}</td>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.item_name}</td>
                        <td>{item.quantityAsPerInvoice}</td>
                        <td>{item.quantityReceived}</td>
                        <td>{item.quantityRejected}</td>
                        <td>{item.remarksForRejection}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectedItemsReport;
